module.exports = __webpack_public_path__ + "img/bobines-foam-packetgrup.c197928e.jpg";